(function($) {
	'use strict';

	$.widget('msv.formpanel', {

		options: {},
		resetForm: function() {
			var self = this;
			self.element.find('input:not([type=radio]):not([type=checkbox]):not(.js-formid)').val(''); //remove all from inputs
			self.element.find('input[type=radio],input[type=checkbox]').prop('checked', false); //uncheck all radiobuttons
			self.element.find('textarea').val(''); //remove all from inputs
			self.element.find('.js-dynamicForm:not(:last)').remove(); // remove all dynamic forms
			self.element.find('.js-upload span').text('') //clean span file
			self.element.find('.js-dropdown').dropdown('reset'); //
			if (grecaptcha)
				grecaptcha.reset()
		},
		_create: function() {
			var self = this;
			this.validator = null;
			this._events();
			self.validator = self.element.validate({
				ignore: [],
				errorPlacement: function(error, element) {
					if (element.attr("type") === "checkbox") {
						$(element).closest('.checkbox-wrap').append($('<p class="js-error"></p>').append(error));
					}
					else if (element.attr("type") === "radio") {
						$(element).closest('.radio-btns-group').append($('<p class="js-error"></p>').append(error));
					}
					else {
						error.insertAfter(element);
					}
					var formItem = $(element).closest(".form-item");
					formItem.addClass("not-valid");
					formItem.find(".btn").addClass("btn-red");
				},
				success: function(el) {
					//self.validator.hideErrors();
					el.closest('form.js-form').find('button.js-submit').removeClass('btn-red');
				}
			});
			this.element.on('submit', function(e) {
				// console.log("submitting form...");
				self.element.find('button.btn').attr('disabled', true).addClass('btn-loading');
				self.element.find('.btn-loading').append("<span class='btn-loading-spinner'></span>");
				e.preventDefault();
				// self.validator = self.element.validate();
				var isValid = self.element.valid();
				if (!isValid) {
					self.element.find('button.btn').attr('disabled', false).addClass('btn-red').removeClass('btn-loading');
					self.element.find(".btn-loading-spinner").remove();
					// console.log("form not valid... exit here");
					return false;
				}

				var parameters = self.element.data('id') ? "&idproduct=" + self.element.data('id') : '';

				var allFields = self.element.serialize() + parameters;
				$.ajax({
					type: "POST",
					crossDomain: true,
					url: self.element.data("endpoint"),
					data: allFields,
					headers: { 'g-captcha-value': self.element.find('input[type=hidden][name=captcha]').val() }
				}).done(function(data, textStatus, jqXHR) {
					self.element.find('button.btn').removeClass('btn-loading');
					self.element.find(".btn-loading-spinner").remove();
					// console.log(textStatus, jqXHR);
					if (jqXHR.status === 200) {
						self.element.find('.form-success-message').html(self.element.data('msg-success')).show();
						self.element.closest('.modal').find('.modal__content').hide();
						self.element.closest('.modal').find('.form-success-message').show();
						self.element.find('button.btn').addClass('btn-green');
						//newsletter
						self.element.parent('.newsletter__field').find('input').hide();
						self.element.parent('.newsletter__field').find('.form-success-message').addClass('show');

						self.resetForm();
						setTimeout(function() {
							self.element.find('.form-success-message').html('').hide();
							self.element.find('button.btn').attr('disabled', false).removeClass('btn-green');
							self.element.closest('.modal').find('.form-success-message').hide();
							self.element.closest('.modal').find('.modal__content').show();
							//newsletter
							self.element.parent('.newsletter__field').find('input').show();
							self.element.parent('.newsletter__field').find('.form-success-message').removeClass('show');
						}, 10000);
						// console.log("Done: all OK");
					}
				}).fail(function(jqXHR) {
					console.log(jqXHR);
					self.element.find('button.btn').attr('disabled', false).addClass('btn-red').removeClass('btn-loading');
					self.element.find(".btn-loading-spinner").remove();
					self.validator.showErrors(BEC.translate(jqXHR.responseJSON));
				});
			});

			self.element.find('.js-form-block .js-next')
				.off('click')
				.on('click', function(e) {
					var el = self.element.find(e.target).hide();
					var id = el.data('next-form-id');
					var partialForm = self.element.find('[data-id=' + id + ']');

					//get previous partial form list
					var previousPartialFormList = self.element.find('[data-id]').filter(function() { return $(this).data('id') < id });
					//Get current and previous partial forms status
					var partialFormIsValid = true;
					previousPartialFormList.each(
						function() {
							$(this).find('input,textarea').each(function() {
								if (!$(this).valid())
									partialFormIsValid = false;
							});
						}
					);

					if (!partialFormIsValid) {
						el.show();
						return;
					}

					partialForm.fadeIn();
					$('html, body').animate({ scrollTop: partialForm.offset().top - 150 }, 500)
				});

			$.validator.addMethod('fullname', function(value) {
				return /^([^0-9]*)$/.test(value);
			});

			$.validator.addMethod('terms', function(value, element) {
				return typeof(value) != 'undefined' && value.toString().toLowerCase() == "true";
			}, 'Para avançar tem de aceitar os Termos de Utilização');

			$("input[type=tel]").on('keypress', function(e) {
				var k = e.keyCode || e.charCode;
				var c = e.charCode;
				var isArrow = (c == 0 && k >= 37 && k <= 40);
				var isSpecial = ((k == 8) || (k == 9) || (k == 127)) || isArrow || (k == 13); // backspace, tab, delete, enter
				var isOK = ((k >= 48 && k <= 57) || k == 43); // numbers  and +
				return isOK || isSpecial;
			});
		},

		_events: function() {
			var self = this;
			this._on({
				"click .btn-red": function(e) {
					e.preventDefault();
					$(e.currentTarget).removeClass("btn-red").removeClass('btn-loading');
					self.validator.resetForm();
				}
			});

			self.element.find('[data-hide-if]').each(function() {
				var el = $(this);
				//var formData = new FormData(self.element[0]);
				var rules = el.data('hide-if');
				Object.keys(rules).forEach(function(elementName) {
					var sourceElement = self.element.find('input[name=' + elementName + ']');
					var values = [];
					if (Array.isArray(rules[elementName]))
						values = rules[elementName];
					else
						values.push(rules[elementName]);


					function sourceElementAvailability() {
						var hide = false;
						el.show();
						el.attr('disabled', false);
						el.find('input,select,textarea').attr('disabled', false);

						values.forEach(function(val) {
							if (!sourceElement.val() || sourceElement.val() == val)
								hide = true;
						});

						if (hide) {
							el.hide();
							el.attr('disabled', true);
							el.find('input,select,textarea').attr('disabled', true);
						}
						else {
							el.show();
							el.attr('disabled', false);
							el.find('input,select,textarea').attr('disabled', false);
						}
					}

					sourceElementAvailability();
					sourceElement.change(sourceElementAvailability);
				});
			})

			//$($('[data-required-if]')[0]).data('required-if').contains('complaint')
			self.element.find('[data-required-if]').each(function() {
				var el = $(this);
				var rules = el.data('required-if'); //{"motive":["complaint","denouncment"]}
				Object.keys(rules).forEach(function(elementName) {
					var sourceElement = self.element.find('input[name=' + elementName + ']');

					function updateRequired() {
						var values = [];

						if (Array.isArray(rules[elementName]))
							values = rules[elementName];
						else
							values.push(rules[elementName]);

						var isRequired = values.includes(sourceElement.val());

						var element = null;
						if (el.is('input,textarea,select'))
							element = el;
						else
							element = el.find('input,textarea,select');

						try {
							if (element) {
								if (isRequired) {
									element.attr('required', true);
									element.rules('add', { required: true });
								}
								else {
									element.attr('required', false);
									element.rules('remove', 'required');
									element.valid();
								}
							}
						}
						catch (e) {

						}
						//el.attr('data-rule-required', isRequired).attr('aria-required', isRequired);
						//el.find('input').attr('data-rule-required', isRequired).attr('aria-required', isRequired);
					}

					updateRequired();
					sourceElement.change(updateRequired);
				});

			});
		}

	});

})(jQuery);